'use client'

import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'
import { useHover } from '../HoverContext'
import { getActiveSection } from '../navigationUtils'

interface SecondaryNavClientProps {
  magicMenu: ReactNode
  playingCardsMenu: ReactNode
  storesMenu: ReactNode
  saleMenu: ReactNode | null
}

/**
 * Client component that determines which menu to show based on pathname
 */
export const SecondaryNavClient = ({
  magicMenu,
  playingCardsMenu,
  storesMenu,
  saleMenu,
}: SecondaryNavClientProps) => {
  const pathname = usePathname()
  const { isHovering } = useHover()

  const activeSection = getActiveSection(pathname)
  const showMagicMenu = activeSection === 'magic'
  const showPlayingCardsMenu = activeSection === 'playing-cards'
  const showStoresMenu = activeSection === 'stores'
  const showSaleMenu = activeSection === 'sale' && saleMenu !== null

  if (activeSection === 'sale' && saleMenu === null) {
    return null
  }

  return (
    <div
      className={`relative z-40 mx-auto hidden h-12 border-b border-gray-200 bg-white lg:flex lg:max-w-screen-lg xl:max-w-screen-xl transition-opacity duration-200 ${
        isHovering ? 'opacity-0 invisible' : 'opacity-100 visible'
      }`}
    >
      {showMagicMenu && magicMenu}
      {showPlayingCardsMenu && playingCardsMenu}
      {showStoresMenu && storesMenu}
      {showSaleMenu ? saleMenu : null}
    </div>
  )
}
